import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from "react";
import { BrowserRouter as Router, Redirect } from "react-router-dom"; // Initial setup

import config from "./config";
import { Api } from "./api"; // Components

import { EnquiryForm } from "./components/EnquiryForm";
import { RouterHistory } from "./components/BackButton";
import { UserMenuProvider } from "./components/UserMenu"; // Routes

import { Routes as SearchRoutes } from "./pages/explore/search";
import { Routes as ApartmentsRoutes } from "./pages/explore/apartments";
import { Routes as LandForSaleRoutes } from "./pages/explore/land-for-sale";
import { Routes as TownhomesRoutes } from "./pages/explore/townhomes";
import { Routes as PackageRoutes } from "./pages/explore/package"; // styles

import "./App.scss";
var isDevelopmentCompany = !config.api.get("project") && !config.api.get("neighbourhood");
export var PropertyAppProvider = function PropertyAppProvider(a) {
  var b = a.children,
      c = [].concat(_toConsumableArray(SearchRoutes), _toConsumableArray(PackageRoutes), _toConsumableArray(LandForSaleRoutes));
  return !1, isDevelopmentCompany || (c = [].concat(_toConsumableArray(c), _toConsumableArray(ApartmentsRoutes), _toConsumableArray(TownhomesRoutes))), /*#__PURE__*/React.createElement(EnquiryForm, null, /*#__PURE__*/React.createElement(Api, {
    url: config.get("api.url")
  }, /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(RouterHistory, {
    routes: c
  }, /*#__PURE__*/React.createElement(UserMenuProvider, null, b)))));
};
export default PropertyAppProvider;